export default "__VITE_ASSET__Dl6uu75s__"